import React, { useRef } from "react";

import { HouseOutlined } from "@mui/icons-material";
import { Box, Card, Container } from "@mui/material";
import DashboardWidgetCard from "../DashboardHomeScreen/shared/DashboardWidgetCard";
import OpenInNewTabButton from "../../components/ui/buttons/OpenInNewTabButton";
import TitledHeader from "../../components/layout/TitledHeader";
import Screen from "../../components/layout/Screen";

const OffMarketPropertyListingsSection = ({ children }) => {
  return (
    <Screen
      sx={{
        position: "absolute",
        left: 0,
        top: 0,
        width: "100%",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        // gap: 2,
        backgroundColor: "#f5f5f5",
      }}
    >
      <TitledHeader
        title={"Off-Market Property Listings"}
        endContent={
          <OpenInNewTabButton
            href={"https://handsomehomebuyer.com/offmarket/"}
          />
        }
        // description="Please provide the necessary details to create a new loan."
      />

      <Container maxWidth="lg" sx={{ height: "100%", position: "relative" }}>
        <Card
          sx={{
            height: "100%",
            py: 3,
            overflow: "hidden",
            position: "relative",
          }}
        >
          <FullHeightIframe />
        </Card>
        {/* <DashboardWidgetCard
          title={`Listings`}
          variant="h3"
          headerSx={{ borderBottom: "1px solid #e0e0e0" }}
          headerEndContent={
            <OpenInNewTabButton
              href={"https://handsomehomebuyer.com/offmarket/"}
            />
          }
          // bodyHeight="1400px"
          cardSx={{
            flexGrow: 1,
            //
            // height: "100%",
          }}
          icon={<HouseOutlined />}
          bodySx={{
            overflow: "hidden",
            //
            height: "1400px",
            // height: "1400px",
          }}
        >
          <FullHeightIframe />
        </DashboardWidgetCard> */}
      </Container>
    </Screen>
  );
};

const FullHeightIframe = () => {
  const iframeRef = useRef(null);

  return (
    <Box
      component="iframe"
      ref={iframeRef}
      src="https://handsomehomebuyer.com/offmarket/"
      className="w-full border-0"
      sx={{
        // mt: "-138px",
        width: "100%",
        // minHeight: "600px",
        position: "absolute",
        top: 0,
        left: 0,
        height: "100%",
        // height: "calct(100% + 138px)",
        border: "none",
      }}
      title="Off Market Properties"
      sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
    />
  );
};
export default OffMarketPropertyListingsSection;
